import MuiBox from '@material-ui/core/Box';
import InputAdornment from '@material-ui/core/InputAdornment';
import MuiInputBase from '@material-ui/core/InputBase';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';
import React from 'react';
import styled from 'styled-components';
import { ERROR, HIGHLIGHT, PLACEHOLDER, TEXT } from '../Colors';
import { Container } from '../Container';
import { BODY, MINI_HEADER } from '../Fonts';
import { IconButton } from '../IconButton';
import { SEARCH } from '../Svgs';

const StyledTextField = withStyles({
    root: {
        width: '100%',
        '& .MuiInputLabel-root': { // Label as placeholder
            font: BODY,
            color: PLACEHOLDER
        },
        '& .MuiInputLabel-root.Mui-error': { // Label error
            color: ERROR
        },
        '& .MuiInputLabel-root.Mui-error.Mui-focused': { // Label error focused
            color: ERROR
        },
        '& .MuiInputLabel-root.Mui-focused': { // Label on top focused
            color: HIGHLIGHT
        },
        '& .MuiInputLabel-root.Mui-disabled': { // Label on top focused
            opacity: 0.5
        },
        '& .MuiInputLabel-shrink': { // Label on top 
            font: MINI_HEADER,
            transform: 'scale(1.0)'
        },
        '& .MuiInput-root.Mui-disabled': { // Input
            opacity: 0.5
        },
        '& .MuiInput-input': { // Input
            font: BODY,
            color: TEXT
        },
        '& .MuiInput-input:focus': { // Input focused
            color: PLACEHOLDER
        },
        '& .MuiInput-underline.Mui-error:after': {
            borderBottom: `1px solid ${TEXT}`
        },
        '& .MuiInput-underline.Mui-error.Mui-focused:after': {
            borderBottom: `1px solid ${HIGHLIGHT}`
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: `2px solid ${TEXT}`
        },
        '& .MuiInput-underline.Mui-focused:hover:not(.Mui-disabled):before': {
            borderBottomWidth: '1px'
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: TEXT
        },
        '& .MuiInput-underline:after': {
            borderBottom: `1px solid ${HIGHLIGHT}`
        },
        '& .MuiFormHelperText-root.Mui-error': {
            font: MINI_HEADER,
            color: ERROR
        },
        '& .MuiInputAdornment-root': {
            color: TEXT,
            width: '30px',
            height: '30px'
        }
    },
})(MuiTextField);

const StyledInputBase = withStyles({
    root: {
        flex: 1,
        color: TEXT,
        font: BODY
    },
})(MuiInputBase);

const StyledIconButtonContainer = styled.span`
    height: 30px;
    width: 30px;
`;

const useStyles = makeStyles({
    hidden: {
        display: 'none',
    }
});

interface SearchFieldProps {
    value?: string,
    placeholder?: string,
    hidden?: boolean,
    disabled?: boolean,
    autoFocus?: boolean,
    contained?: boolean,
    onChange?(value: string): void
    onSearchClick?(value: string): void
}

export const SearchField: React.FunctionComponent<SearchFieldProps> = (props) => {
    const classes = useStyles();

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    const onChange = (value: string) => {
        if (props.onChange) {
            props.onChange(value);
        }
    }

    const onSearchClick = (value: string) => {
        if (props.onSearchClick) {
            props.onSearchClick(value);
        }
    }

    const className = `${props.hidden ? classes.hidden : ''} ${stylingClassName}`;

    if (!props.contained) {
        return (
            <StyledTextField
                className={className}
                placeholder={props.placeholder || "Search"}
                value={props.value}
                disabled={props.disabled}
                autoFocus={props.autoFocus}
                onChange={ev => onChange(ev.target.value)}
                InputProps={{
                    endAdornment: (<InputAdornment position="end">
                        <IconButton type="secondary" fullWidth fullHeight onClick={() => onSearchClick(props.value)}>{SEARCH}</IconButton>
                    </InputAdornment>)
                }} />
        );
    } else {
        return (<Container>
            <MuiBox display="flex" flexDirection="row" margin="-4px 0">
                <StyledInputBase
                    className={className}
                    placeholder={props.placeholder || "Search"}
                    value={props.value}
                    disabled={props.disabled}
                    autoFocus={props.autoFocus}
                    onChange={ev => onChange(ev.target.value)} />
                <StyledIconButtonContainer>
                    <IconButton type="secondary" fullWidth fullHeight onClick={() => onSearchClick(props.value)}>{SEARCH}</IconButton>
                </StyledIconButtonContainer>
            </MuiBox>
        </Container>);
    }
}
